class HeroBanner {
  constructor() {
    this.init();
  }

  init() {
    this.setColorVariables();
    this.addScrollEffects();
    this.addIntersectionObserver();
  }

  setColorVariables() {
    // Set CSS custom properties for colors
    const root = document.documentElement;
    
    // Get color values from data attributes or use defaults
    const heading = document.querySelector('.hero-banner__heading');
    if (heading) {
      const mobileColor = heading.dataset.mobileColor || '#000000';
      const desktopColor = heading.dataset.desktopColor || '#000000';
      
      root.style.setProperty('--mobile-heading-color', mobileColor);
      root.style.setProperty('--desktop-heading-color', desktopColor);
    }
    
    const subheading = document.querySelector('.hero-banner__subheading');
    if (subheading) {
      const mobileColor = subheading.dataset.mobileColor || '#333333';
      const desktopColor = subheading.dataset.desktopColor || '#333333';
      
      root.style.setProperty('--mobile-subheading-color', mobileColor);
      root.style.setProperty('--desktop-subheading-color', desktopColor);
    }
    
    const button = document.querySelector('.hero-banner__button');
    if (button) {
      const mobileBg = button.dataset.mobileBg || '#000000';
      const desktopBg = button.dataset.desktopBg || '#000000';
      const mobileText = button.dataset.mobileText || '#ffffff';
      const desktopText = button.dataset.desktopText || '#ffffff';
      
      root.style.setProperty('--mobile-button-bg', mobileBg);
      root.style.setProperty('--desktop-button-bg', desktopBg);
      root.style.setProperty('--mobile-button-text', mobileText);
      root.style.setProperty('--desktop-button-text', desktopText);
    }
    
    const trust = document.querySelector('.hero-banner__trust');
    if (trust) {
      const mobileColor = trust.dataset.mobileColor || '#666666';
      const desktopColor = trust.dataset.desktopColor || '#666666';
      
      root.style.setProperty('--mobile-trust-color', mobileColor);
      root.style.setProperty('--desktop-trust-color', desktopColor);
    }
  }

  addScrollEffects() {
    const hero = document.querySelector('.hero-banner');
    if (!hero) return;

    window.addEventListener('scroll', () => {
      const scrolled = window.pageYOffset;
      const rate = scrolled * -0.5;
      
      if (hero.querySelector('.hero-banner__background-image')) {
        hero.querySelector('.hero-banner__background-image').style.transform = `translateY(${rate}px)`;
      }
    });
  }

  addIntersectionObserver() {
    const hero = document.querySelector('.hero-banner');
    if (!hero) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('hero-banner--visible');
        }
      });
    }, {
      threshold: 0.1
    });

    observer.observe(hero);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new HeroBanner();
});

// Initialize for dynamic content (Shopify sections)
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.classList.contains('hero-banner')) {
    new HeroBanner();
  }
});

// Initialize for section updates
document.addEventListener('shopify:section:reorder', () => {
  new HeroBanner();
});

document.addEventListener('shopify:section:select', () => {
  new HeroBanner();
});